import * as React from "react";
import { FormProvider } from "react-hook-form";
import { cx } from "../internal/cx.js";

export type FormDensity = "comfortable" | "compact";

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  density?: FormDensity;
}

/**
 * Layout shell for groups of fields and actions. Sets the shared
 * spacing rhythm via `cw-v2-form` + `cw-v2-form--<density>` classes.
 * Pair with `<FormProvider>` (re-exported below) when wiring
 * react-hook-form state around the visual form.
 */
export const Form = React.forwardRef<HTMLFormElement, FormProps>(function Form(
  { className, density = "comfortable", ...props },
  ref,
) {
  return (
    <form ref={ref} className={cx("cw-v2-form", `cw-v2-form--${density}`, className)} {...props} />
  );
});
Form.displayName = "Form";

export { FormProvider };
